module.exports = __webpack_public_path__ + "img/analytics-download-bg.a08d025c.png";